import React from 'react';
import { Route } from 'react-router-dom';
import Teachers from '../pages/teachers/Teachers';
import TeachersArchive from '../pages/teachers/TeachersArchive';
import CreateTeacher from '../pages/teachers/CreateTeacher';
import EditTeacher from '../pages/teachers/EditTeacher';
import PermissionGuard from '../components/global/PermissionGuard';

const teachersRoutes = (
    <>
        <Route path="/teachers" element={<PermissionGuard permission="teachers_list"><Teachers /></PermissionGuard>} />
        <Route path="/teachers/archive" element={<PermissionGuard permission="teachers_archive_list"><TeachersArchive /></PermissionGuard>} />
        <Route path="/teachers/create" element={<PermissionGuard permission="teachers_create"><CreateTeacher /></PermissionGuard>} />
        <Route path="/teachers/:id/edit" element={<PermissionGuard permission="teachers_edit"><EditTeacher /></PermissionGuard>} />
    </>
);

export default teachersRoutes;
